// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Rack Viewer Styles */

/* Lienzo de diseño A SANGRE, igual que el mapa de planta (\`FloorPlanMap\`).
 *
 * Antes era una tarjeta con borde, esquinas y sombra, y \`height: calc(100vh -
 * 150px)\`: en una pantalla grande el conjunto quedaba como una isla centrada
 * con aire por los cuatro lados (y el alto no cuadraba con el layout). Ahora la
 * ruta entra en \`isCanvasRoute\` (ver \`MainLayout.jsx\`): sin el relleno del
 * \`main-content\` ni el tope de 1400 px, y el visor hereda el alto del layout y
 * lo reparte con flex. La cabecera y los paneles interiores llegan hasta los
 * bordes: ni un píxel muerto entre el menú lateral y el rack.
 * No es "pantalla completa": la barra superior y el menú lateral siguen ahí. */
.rack-viewer-container {
  animation: fadeIn 0.3s ease;
  display: flex;
  flex-direction: column;
  /* Alto heredado del layout (\`.content-wrapper.is-canvas > *\` ya le da
   * \`flex: 1\`): un \`height\` fijo contra el viewport dejaba franjas muertas. */
  flex: 1 1;
  height: 100%;
  min-height: 0;
  padding: 0;
  overflow: hidden;
  background: var(--bg-card);
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.rack-viewer-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--border);
}

.rack-viewer-header h1 {
  margin-bottom: 0.5rem;
}

.rack-viewer-header p {
  color: var(--text-muted);
  margin: 0;
}

.rack-viewer-content {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 2rem;
}

.rack-diagram {
  background-color: var(--bg-card);
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.4);
}

.rack-viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.rack-viewer-grid {
  display: grid;
  flex: 1 1;
  min-height: 0;
  /* Los paneles laterales tienen tope: el ancho que sobre es para el rack. */
  grid-template-columns: minmax(170px, 210px) minmax(0, 1fr) minmax(230px, 280px);
  /* UNA fila que mide exactamente el hueco disponible. Sin esto la fila crecía
   * con el contenido (42U ≈ 1.600 px) y el rack se salía del lienzo. */
  grid-template-rows: minmax(0, 1fr);
  gap: 10px;
  align-items: stretch;
  /* Sin relleno: los paneles tocan el menú lateral, la cabecera y el borde
   * inferior. El aire va DENTRO de cada panel, no alrededor del lienzo. */
  padding: 0;
}

/* En pantallas estrechas el panel de información estorba más que ayuda (es el
 * mismo criterio que ya usaba el modo pantalla completa). */
@media (max-width: 1180px) {
  .rack-viewer-grid {
    grid-template-columns: minmax(160px, 190px) minmax(0, 1fr);
  }
  .rack-viewer-grid > .rack-side { display: none; }
}

@media (max-width: 900px) {
  .rack-viewer-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-viewer-grid > .rack-unplaced { display: none; }
}

/* Los paneles interiores no llevan sombra propia: la superficie ya la tiene. */
.rack-unplaced, .rack-side, .rack-board {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px;
  box-shadow: none;
  min-height: 0;
  max-height: 100%;
}

/* A sangre las esquinas redondeadas de los paneles exteriores quedan pegadas a
 * los bordes de la ventana y parecen un hueco: se cuadran. En pantalla completa
 * (\`.rv--fullscreen\`) hay margen, así que conservan su radio. */
.rack-viewer-container:not(.rv--fullscreen) :is(.rack-unplaced, .rack-side, .rack-board) {
  border-radius: 0;
}

.rack-unplaced-list {
  flex: 1 1;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rack-chip {
  border: 1px solid var(--slate-300);
  border-radius: 10px;
  padding: 8px 10px;
  background: var(--bg-input);
  cursor: grab;
  transition: opacity 0.15s, box-shadow 0.15s;
}

.rack-chip--dragging {
  opacity: 0.4;
}

.rack-chip:hover {
  border-color: #93c5fd;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.rack-unplaced-hint {
  font-size: 0.7rem;
  color: #9ca3af;
  text-align: center;
  padding: 4px 0 8px;
  border-bottom: 1px dashed var(--slate-300);
  margin-bottom: 8px;
}

.rack-unplaced--over {
  background: rgba(59,130,246,.1);
  border-color: #3b82f6;
  border-style: dashed;
}

.rack-slot--over {
  background: rgba(59, 130, 246, 0.08);
  border-color: #3b82f6 !important;
  border-style: dashed !important;
}

/* Rear slot blocked by a full-depth front element */
.rack-slot--blocked {
  background: repeating-linear-gradient(
    45deg,
    var(--border),
    var(--border) 5px,
    var(--bg-toolbar) 5px,
    var(--bg-toolbar) 10px
  );
  cursor: not-allowed !important;
  opacity: 0.75;
}

.rack-item--dragging {
  opacity: 0.35;
  cursor: grabbing;
}

/* Elemento resaltado al llegar con ?destacar=<id> (p. ej. «Ver rack» desde la
   ficha de un servidor). Parpadea unas veces y se apaga solo. */
.rack-item--highlight {
  outline: 3px solid var(--amber-600);
  outline-offset: 1px;
  z-index: 4;
  animation: rack-item-pulse 1.1s ease-in-out 3;
}

@keyframes rack-item-pulse {
  0%, 100% { box-shadow: 0 0 0 0 transparent; }
  50%      { box-shadow: 0 0 0 5px var(--amber-600); }
}

.rack-board {
  overflow-x: auto;
  /* El tablero es una columna flex: las barras arriba con su alto natural y el
   * rack con el resto, sin desbordar el lienzo. */
  display: flex;
  flex-direction: column;
  min-height: 0;
  /* Ancla del tooltip de los puertos (\`.rv-cable-tip\`). */
  position: relative;
}

.rack-dual {
  display: grid;
  /* Frontal | canal de cableado (estrecho) | trasero. Los cables no cruzan. */
  grid-template-columns: minmax(0, 1fr) clamp(42px, 6vw, 96px) minmax(0, 1fr);
  /* Barras de acción con alto natural y la fila de los tres paneles con todo
   * lo que sobra: así el scroll vive dentro de las U y no se sale del lienzo. */
  grid-template-rows: auto auto minmax(0, 1fr);
  column-gap: 6px;
  row-gap: 12px;
  flex: 1 1;
  min-height: 0;
  position: relative;
}
/* En pantalla completa las barras viven en el rail (no dentro del rack). */
.rv--fullscreen .rack-dual {
  grid-template-rows: minmax(0, 1fr);
}
/* En modo tablet solo se pinta la barra de accesorios (el alta rápida está en
 * la barra inferior). */
.rv--touch .rack-dual {
  grid-template-rows: auto minmax(0, 1fr);
}
/* Las barras de acción van dentro del grid: deben ocupar la fila entera para
   no robar una columna a los tres paneles del rack. */
.rack-dual > .rack-add-toolbar,
.rack-dual > .rack-filler-toolbar {
  grid-column: 1 / -1;
  /* El aire entre filas ya lo pone \`row-gap\`: con el margen propio se sumaban
   * 22 px de hueco muerto antes del rack. */
  margin-bottom: 0;
}

.rack-panel {
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Los dos paneles laterales se estiran hasta la altura del rack y hacen su
 * propio scroll: así el conjunto no queda como un pegote a media altura. */
.rack-unplaced,
.rack-side {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.rack-unplaced .d-flex,
.rack-side .rv-spec-header {
  flex-shrink: 0;
}

/* ─── Dual panel (front + rear) ─── */
.rack-dual {
  display: grid;
  grid-template-columns: minmax(0, 1fr) clamp(42px, 6vw, 96px) minmax(0, 1fr);
  column-gap: 6px;
  row-gap: 12px;
}

.rack-panel {
  min-width: 0;
}

/* ─── Columna central de cableado ─── */
.rack-panel--duct {
  min-width: 0;
}
.rack-panel-label--duct {
  background: rgba(148, 163, 184, 0.16);
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Especificidad extra: \`.rack-columns\` (más abajo) fija 46px 1fr para la escala. */
.rack-panel--duct .rack-columns--duct {
  grid-template-columns: 1fr;
  padding-right: 0;
}
.rack-canvas--duct {
  background:
    repeating-linear-gradient(90deg, rgba(148, 163, 184, 0.10) 0 2px, transparent 2px 12px),
    linear-gradient(180deg, rgba(148, 163, 184, 0.10) 0%, rgba(148, 163, 184, 0.04) 100%);
  border-style: dashed;
  /* Deja que el cable sobresalga para empalmar con el tramo del frontal. */
  overflow: visible;
}
.rack-canvas--duct .rv-cables {
  z-index: 2;
  overflow: visible;
}

.rack-panel-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 4px 10px;
  border-radius: 6px;
  margin-bottom: 6px;
  display: inline-block;
}

.rack-panel-label--front {
  background: rgba(59,130,246,.18);
  color: #93c5fd;
}

.rack-panel-label--rear {
  background: rgba(250,204,21,.18);
  color: #fde047;
}

.rack-columns {
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 2px;
  /* Scroll propio: 42U × 38 px son ~1.600 px, así que las U se desplazan dentro
   * de su columna y la cabecera del rack y el panel lateral no se van de la
   * vista. El alto lo reparte el flex del lienzo: con un \`max-height\` en px
   * contra el viewport, en cuanto cambiaba el alto de la cabecera el rack
   * quedaba recortado. */
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding-right: 2px;
}
/* La columna del canal no lleva escala: una sola pista. */
.rack-columns.rack-columns--duct {
  grid-template-columns: 1fr;
  padding-right: 0;
}

.rack-scale {
  display: grid;
  grid-auto-rows: 36px;
  gap: 2px;
  justify-items: center;
  align-content: start;
  color: var(--text-secondary);
  font-size: 9.5px;
}

.rack-canvas {
  display: grid;
  grid-auto-rows: 36px;
  /* Una sola columna que mide EXACTAMENTE el ancho del rack: sin esto la
     columna crece con el texto de la banda y los puertos se van a la derecha. */
  grid-template-columns: minmax(0, 1fr);
  gap: 2px;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0;
  overflow: hidden;
  align-content: start;
  background: linear-gradient(180deg, rgba(255,255,255,.04) 0%, rgba(255,255,255,.02) 100%);
  position: relative;
}

/* Barra de capas (colocación / cableado) */
.rv-layer-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}
.rv-layer-switch {
  display: inline-flex;
  padding: 2px;
  border-radius: 9px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar, var(--bg-card));
  gap: 2px;
}
.rv-layer-switch button {
  border: 0;
  background: transparent;
  color: var(--text-muted);
  font-size: 0.76rem;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 7px;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.rv-layer-switch button:hover { color: var(--text-primary); }
.rv-layer-switch button.is-on {
  background: var(--bg-card);
  color: var(--text-primary);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);
}
.rv-layer-count {
  font-size: 0.72rem;
  color: var(--text-muted);
}

/* Capa de cableado: el texto de la banda estorba sobre los puertos → tooltip. */
.rack-board.is-cabling .rack-item-row,
.rack-board.is-cabling .rack-item-header,
.rack-board.is-cabling .rack-item-type,
.rack-board.is-cabling .rack-item-ports {
  display: none;
}
.rack-board.is-cabling .rack-item {
  cursor: grab;
}

/* Capa ÚNICA de cables sobre el tablero. Acompaña al scroll con un translate
   del grupo interior, así nunca se queda «pegada». Recorta a la ventana visible. */
.rv-cable-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 6;
  overflow: hidden;
}
.rv-cable {
  fill: none;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0.9;
  transition: stroke-width 0.12s, opacity 0.12s;
}
.rv-cable.is-backbone {
  stroke-width: 2;
  opacity: 1;
}
/* Cable iluminado: más grueso y con corriente recorriéndolo. */
.rv-cable.is-hot {
  stroke-width: 3;
  opacity: 1;
  stroke-dasharray: 7 5;
  filter: drop-shadow(0 0 4px currentColor);
  animation: rv-flow 0.55s linear infinite;
}
/* Cuando hay un camino encendido, el resto de cables se apaga. */
.rv-cable.is-dim { opacity: 0.12; }
@keyframes rv-flow {
  to { stroke-dashoffset: -12; }
}
@media (prefers-reduced-motion: reduce) {
  .rv-cable.is-hot { animation: none; }
}

/* Puertos del frontal: cubren toda la banda; la rejilla la pone el inline-style. */
.rv-ports {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
/* Conector RJ45 estilizado: cuerpo con la pestaña (clip) abajo y los contactos
   dorados dentro. Tamaño lo pone el inline-style (se reparte por la U). */
.rv-port {
  position: absolute;
  padding: 0;
  border: 0;
  background: transparent;
  pointer-events: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.08s, filter 0.12s;
}
.rv-port-jack {
  position: absolute;
  inset: 0;
  border: 1px solid rgba(15, 23, 42, 0.55);
  border-radius: 2px 2px 3px 3px;
  background:
    linear-gradient(#f8fafc, #e2e8f0),
    repeating-linear-gradient(90deg, rgba(180, 130, 20, 0.55) 0 1px, transparent 1px 3px);
  background-blend-mode: multiply;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}
/* Pestaña del conector (el clip del RJ45) */
.rv-port-jack::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -2px;
  width: 40%;
  height: 3px;
  transform: translateX(-50%);
  border-radius: 0 0 2px 2px;
  background: inherit;
  border: 1px solid rgba(15, 23, 42, 0.45);
  border-top: 0;
}
.rv-port-num {
  position: relative;
  z-index: 1;
  font-size: 7px;
  font-weight: 700;
  line-height: 1;
  color: #334155;
  pointer-events: none;
}
.rv-port:hover { transform: scale(1.12); z-index: 3; }
.rv-port:hover .rv-port-jack {
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.7);
}
.rv-port.is-busy .rv-port-jack {
  background: linear-gradient(#3b82f6, #2563eb);
  border-color: #1d4ed8;
}
.rv-port.is-busy .rv-port-num { color: #eff6ff; }
.rv-port.is-selected .rv-port-jack {
  background: linear-gradient(#fbbf24, #f59e0b);
  border-color: #b45309;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.7);
}
/* Puerto iluminado (él o su cable al pasar el ratón) */
.rv-port.is-hot {
  transform: scale(1.3);
  z-index: 4;
}
.rv-port.is-hot .rv-port-jack {
  background: linear-gradient(#fb923c, #f97316);
  border-color: #c2410c;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.5), 0 0 8px rgba(249, 115, 22, 0.85);
}
.rv-port.is-hot .rv-port-num { color: #fff7ed; }

/* Tooltip del puerto con los equipos conectados */
.rv-cable-tip {
  position: absolute;
  z-index: 30;
  min-width: 190px;
  max-width: 320px;
  padding: 7px 9px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-card, #fff);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);
  font-size: 0.72rem;
  color: var(--text-primary);
  pointer-events: none;
  /* Anclado a la izquierda del puerto: su borde derecho queda en \`left\`. */
  transform: translateX(-100%);
}
.rv-cable-tip-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  font-weight: 700;
  margin-bottom: 4px;
}
.rv-cable-tip-head span {
  font-weight: 600;
  color: var(--text-muted);
}
.rv-cable-tip-row {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 2px 0;
  border-top: 1px solid var(--border);
}
.rv-cable-tip-row em {
  font-style: normal;
  font-size: 0.68rem;
  color: var(--text-muted);
}
/* Sede de una toma de pared: el otro extremo no está en este armario. */
.rv-cable-tip-loc {
  font-size: 0.68rem;
  color: var(--text-muted);
}
.rv-cable-tip-row.is-muted { color: var(--text-muted); }

/* Barra de conexión en el propio rack */
.rv-connect-hint,
.rv-connect-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.6rem;
  border-radius: 10px;
  font-size: 0.78rem;
  border: 1px solid var(--border);
  background: var(--bg-card);
}
.rv-connect-hint {
  border-color: rgba(245, 158, 11, 0.55);
  background: rgba(245, 158, 11, 0.10);
}
.rv-connect-hint button {
  margin-left: auto;
  border: 0;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 0.74rem;
  text-decoration: underline;
}
.rv-connect-title { font-weight: 600; }
.rv-connect-title em { margin: 0 6px; font-style: normal; opacity: 0.6; }
.rv-connect-bar select {
  padding: 3px 6px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--bg-surface, #fff);
  color: var(--text-primary);
  font-size: 0.76rem;
}
.rv-connect-bar button {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--bg-surface, #fff);
  color: var(--text-primary);
  font-size: 0.76rem;
  cursor: pointer;
}
.rv-connect-ok {
  background: var(--primary, #2563eb) !important;
  border-color: var(--primary, #2563eb) !important;
  color: #fff !important;
  font-weight: 600;
}
.rv-connect-ok:disabled { opacity: 0.6; cursor: default; }
.rv-connect-error { color: var(--danger, #dc2626); font-size: 0.74rem; }

.rack-slot {
  position: relative;
  min-height: 36px;
  border: 1px dashed transparent;
}

.rack-slot:hover {
  border-color: rgba(148, 163, 184, 0.45);
}

.rack-item {
  width: 100%;
  min-width: 0;
  color: #fff;
  border-radius: 8px;
  padding: 3px 10px;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.3);
  cursor: grab;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1px;
  overflow: hidden;
}

.rack-item-header {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  min-width: 0;
}

/* Compact single-row layout for 1U items */
.rack-item-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  overflow: hidden;
  min-width: 0;
  width: 100%;
}

.rack-item-row .rack-item-title {
  flex: 1 1;
}

.rack-item-row .rack-item-ports {
  flex-shrink: 0;
  margin-top: 0;
}

.rack-item-title {
  font-weight: 700;
  font-size: 13px;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

/* 1U: name fills the slot, slightly larger for legibility */
.rack-item-title--1u {
  font-size: 13px;
  text-align: center;
  flex: none;
  width: 100%;
}

.rack-item-type {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
  margin-top: 1px;
  padding-left: 24px;
}

.rack-item-ports {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  opacity: 1;
  line-height: 1;
  margin-top: 0;
}

.port-count-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid rgba(0,0,0,0.1);
}

.spec-group {
  margin-bottom: 16px;
}

.spec {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  font-size: 13px;
  color: var(--text-primary);
}

.spec span:first-child {
  color: var(--text-secondary);
}

.spec span:last-child {
  text-align: right;
  font-weight: 600;
}

.spec--stacked {
  flex-direction: column;
  gap: 6px;
}

.rv-inline-help {
  display: block;
  font-size: 0.72rem;
  line-height: 1.4;
  color: var(--text-secondary);
}

/* Print Styles */
@media print {
  .sidebar {
    display: none;
  }
}

/* ─────────────────────────────────────────────────────────
   Cabecera
   Va con los tokens del tema: antes era un degradado azul marino fijo que
   chocaba con cualquier paleta clara y dejaba las etiquetas de los KPIs
   (color secundario del tema) casi ilegibles sobre el fondo oscuro.
   ───────────────────────────────────────────────────────── */
.rv-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  /* A sangre: el contenido arranca alineado con el de los paneles (12 px de
   * relleno + 1 px de borde), no con un margen propio de tarjeta. */
  padding: 0.75rem 13px;
  margin-bottom: 0;
  background-color: transparent;
  background-image: linear-gradient(
    120deg,
    rgba(var(--accent-rgb), 0.14) 0%,
    rgba(var(--accent-rgb), 0.04) 42%,
    transparent 70%
  );
  border-bottom: 1px solid var(--border);
  border-radius: 0;
  color: var(--text-primary);
  box-shadow: none;
}

.rv-header-left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

/* Icono del rack: el mismo \`RectangleStackIcon\` que el listado de racks, no el
 * emoji 🗄️, que se pintaba con los colores de la fuente y no pegaba con nada. */
.rv-rack-glyph {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  color: var(--accent-l);
  stroke-width: 1.6;
}

.rv-header-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.rv-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.rv-rack-name {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.1;
}

.rv-code-pill {
  background: rgba(var(--accent-rgb), 0.16);
  color: var(--accent-l);
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  border: 1px solid rgba(var(--accent-rgb), 0.3);
  text-transform: uppercase;
}

.rv-location-pill {
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 0.72rem;
  border: 1px solid var(--border);
}

.rv-rack-desc {
  margin: 0;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.rv-header-stats {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.rv-stat-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 5px 14px;
  min-width: 58px;
}

/* Semáforo de ocupación con los tokens funcionales del tema: en las paletas
 * claras el número oscurece y el fondo se tiñe poco; en las oscuras al revés. */
.rv-stat-chip--used    { background: rgba(239, 68, 68, 0.14); border-color: rgba(239, 68, 68, 0.34); }
.rv-stat-chip--free    { background: rgba(34, 197, 94, 0.14); border-color: rgba(34, 197, 94, 0.32); }
.rv-stat-chip--depth   { background: rgba(14, 165, 233, 0.14); border-color: rgba(14, 165, 233, 0.32); }
.rv-stat-chip--pending { background: rgba(251, 191, 36, 0.16); border-color: rgba(251, 191, 36, 0.36); }

.rv-stat-n {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
}

.rv-stat-chip--used    .rv-stat-n { color: var(--red-600); }
.rv-stat-chip--free    .rv-stat-n { color: var(--green-600); }
.rv-stat-chip--depth   .rv-stat-n { color: var(--blue-500); }
.rv-stat-chip--pending .rv-stat-n { color: var(--amber-600); }

.rv-stat-lbl {
  font-size: 0.6rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 2px;
}

.rv-saving-pill {
  background: rgba(251, 191, 36, 0.16);
  border: 1px solid rgba(251, 191, 36, 0.4);
  color: var(--amber-600);
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 600;
  animation: rv-pulse 1.2s ease-in-out infinite;
}

@keyframes rv-pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.6; }
}

/* ─────────────────────────────────────────────────────────
   Sidebar: legend + occupancy + section headers
   ───────────────────────────────────────────────────────── */
.rv-spec-header {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-secondary);
  padding-bottom: 6px;
  margin-bottom: 6px;
  border-bottom: 1px solid var(--border);
}

.rv-legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px 10px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
}

.rv-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: var(--text-primary);
}

.rv-dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
}

.rv-dot--server { background: #007bff; }
.rv-dot--switch { background: #28a745; }
.rv-dot--panel  { background: #17a2b8; }
.rv-dot--pdu    { background: #ffc107; }

.rv-occupancy {
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
}

.rv-capacity-row {
  margin-bottom: 10px;
}

.rv-capacity-row-head {
  display: flex;
  justify-content: space-between;
  font-size: 0.74rem;
  color: var(--text-secondary);
  font-weight: 500;
  margin-bottom: 5px;
}

.rv-capacity-track {
  height: 7px;
  background: rgba(148, 163, 184, 0.18);
  border-radius: 4px;
  overflow: hidden;
}

.rv-capacity-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.6s ease;
}

.rv-capacity-fill--front {
  background: linear-gradient(90deg, #38bdf8 0%, #2563eb 100%);
}

.rv-capacity-fill--rear {
  background: linear-gradient(90deg, #f59e0b 0%, #ef4444 100%);
}

.rv-occupancy-help {
  margin-top: 8px;
  font-size: 0.73rem;
  color: var(--text-secondary);
  line-height: 1.4;
}

.rv-power-panel {
  margin-bottom: 14px;
}

.rv-power-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

.rv-power-summary-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 6px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.08);
  min-width: 0;
  overflow: hidden;
}

.rv-power-summary-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rv-power-summary-label {
  font-size: 0.62rem;
  line-height: 1.15;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--text-secondary);
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
}

.rv-power-pdu-row {
  margin-bottom: 10px;
}

.rv-power-pdu-head {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
  font-size: 0.75rem;
}

.rv-power-pdu-name {
  font-weight: 600;
  color: var(--text-primary);
}

.rv-power-pdu-metric {
  color: var(--text-secondary);
}

.rv-power-track {
  height: 7px;
  background: rgba(148, 163, 184, 0.18);
  border-radius: 999px;
  overflow: hidden;
}

.rv-power-devices {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.rv-power-devices-title {
  margin-bottom: 6px;
  font-size: 0.68rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-secondary);
  font-weight: 700;
}

.rv-power-device-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.rv-power-device-name {
  min-width: 0;
  font-size: 0.75rem;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rv-power-state {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.rv-power-state--ok {
  background: rgba(34, 197, 94, 0.18);
  color: #166534;
}

.rv-power-state--warn {
  background: rgba(245, 158, 11, 0.18);
  color: #92400e;
}

.rv-power-state--off {
  background: rgba(239, 68, 68, 0.18);
  color: #991b1b;
}

.rv-empty-note {
  font-size: 0.74rem;
  color: var(--text-secondary);
}

@media (max-width: 1024px) {
  .rack-viewer-grid {
    grid-template-columns: 1fr;
    /* Aquí sí quedan dos filas (pendientes + tablero): el panel de pendientes
     * se lleva algo menos de un tercio y el rack el resto, ambos con scroll
     * interior. Con una sola fila \`1fr\` el tablero se salía del lienzo. */
    grid-template-rows: minmax(0, 0.34fr) minmax(0, 1fr);
  }

  .rack-unplaced-list {
    max-height: none;
  }

  .rv-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .rv-power-summary-grid {
    grid-template-columns: 1fr;
  }
}

/* Por debajo de 900 px el panel de pendientes ya no se pinta: el tablero se
   queda con toda la fila (si no, se quedaría con el 66 % del alto). */
@media (max-width: 900px) {
  .rack-viewer-grid {
    grid-template-rows: minmax(0, 1fr);
  }
}

/* ─── Rack Filler Toolbar ─── */
.rack-filler-toolbar {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.rack-filler-toolbar-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

.rack-filler-btn {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border: 1.5px solid var(--border);
  border-radius: 6px;
  background: var(--bg-card);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.rack-filler-btn:hover {
  border-color: rgba(148, 163, 184, 0.5);
  background: rgba(255,255,255,.04);
}

.rack-filler-btn--active {
  color: #fff;
  border-color: transparent;
}

.rack-filler-hint {
  font-size: 0.7rem;
  color: var(--text-secondary);
  font-style: italic;
}

/* ─── Filler Item (inside rack slot) ─── */
.rack-filler-item {
  width: 100%;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.15s;
  letter-spacing: 0.02em;
}

.rack-filler-item:hover {
  opacity: 1;
  outline: 2px dashed var(--text-secondary);
  outline-offset: -2px;
}

/* ─── Alta rápida desde el visor (barra + diálogo) ─── */
.rack-add-toolbar {
  margin-bottom: 6px;
}

/* ─── Modo diseño (rack en borrador) ─── */
.rv-design-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 12px 0;
  padding: 10px 14px;
  border: 1px solid rgba(245, 158, 11, 0.45);
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  background: rgba(245, 158, 11, 0.12);
  color: var(--text-primary);
  font-size: 0.84rem;
}

.rv-design-banner-text {
  line-height: 1.35;
}

.rv-design-banner-btn {
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  background: #f59e0b;
  color: #fff;
  font-weight: 600;
  font-size: 0.82rem;
  cursor: pointer;
  white-space: nowrap;
}

.rv-design-banner-btn:hover {
  background: #d97706;
}

.rack-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border-width: 1.5px;
}

.rack-add-btn:hover {
  background: rgba(148, 163, 184, 0.12);
}

/* Diálogo «Nuevo switch / patch panel / PDU» */
.rqc-context {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 0.9rem;
}

.rqc-chip {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
}

.rqc-name-row {
  display: flex;
  gap: 6px;
  align-items: center;
}

.rqc-ports-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.rqc-preset--active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.rqc-ports-input {
  width: 72px;
  min-width: 72px;
  text-align: center;
}

.rqc-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

.rqc-grid select {
  width: 100%;
  min-width: 0;
}

.rqc-warn {
  margin: 0.75rem 0 0;
  font-size: 0.75rem;
  line-height: 1.4;
  color: var(--amber-600, #b45309);
}

.rqc-error {
  margin: 0.75rem 0 0;
  font-size: 0.78rem;
  color: var(--red-500, #ef4444);
}

/* ═══════════════════════════════════════════════════════════════════════════
   Pantalla completa — modo «trabajo»

   Objetivo: montar y recolocar equipos sin pelear con la página. El rack se
   lleva todo el alto/ancho y las herramientas (añadir equipo, añadir accesorio),
   los KPIs y las U pendientes se apilan en una barra lateral izquierda. El panel
   de detalle (capacidad, alimentación, elemento seleccionado) sigue a la derecha.

   La geometría es flex, NO la medición en JS: aquí la cabecera de la app y el
   menú lateral no existen, así que \`.rack-columns\` se reparte el alto sobrante
   con \`flex: 1\` y se queda con su propio scroll.
   ═══════════════════════════════════════════════════════════════════════════ */

.rv-fs-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.rv-fs-btn:hover {
  background: rgba(var(--accent-rgb), 0.14);
  color: var(--text-primary);
  border-color: rgba(var(--accent-rgb), 0.4);
}

.rv--fullscreen {
  /* También sirve de respaldo cuando la Fullscreen API está bloqueada.
     z-index POR DEBAJO de los diálogos (\`.list-overlay\` va en 1200): en el modo
     de respaldo no hay capa superior del navegador, así que si el contenedor
     quedara por encima, los diálogos saldrían invisibles. Por encima del menú
     lateral y la barra superior (1100). */
  position: fixed;
  inset: 0;
  z-index: 1150;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  background: var(--bg-card, #0f172a);
  border: 0;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  /* \`inset: 0\` basta para llenar la ventana; el \`height\` del lienzo normal
     (calc(100vh - 150px)) dejaría el modo pantalla completa a media altura. */
  height: auto;
  min-height: 0;
}

.rv--fullscreen .rv-header {
  margin-bottom: 0;
  padding: 0.5rem 0.9rem;
}

.rv--fullscreen .rv-rack-name { font-size: 1.1rem; }
.rv--fullscreen .rv-rack-desc { display: none; }
.rv--fullscreen .rv-rack-glyph { width: 22px; height: 22px; }

.rv--fullscreen .rack-viewer-grid {
  flex: 1 1;
  min-height: 0;
  grid-template-columns: 186px minmax(0, 1fr) 214px;
  align-items: stretch;
  gap: 12px;
  padding: 0;
}

.rv--fullscreen .rack-board {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.rv--fullscreen .rack-dual {
  flex: 1 1;
  min-height: 0;
}

.rv--fullscreen .rack-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.rv--fullscreen .rack-columns {
  flex: 1 1;
  min-height: 0;
  /* Manda el flex: la medición en px es solo para la vista normal. */
  max-height: none;
}

.rv--fullscreen .rack-side,
.rv--fullscreen .rv-rail {
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* ─── Barra lateral de herramientas ─── */
.rv-rail {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}

.rv-rail .rack-filler-toolbar {
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  margin-bottom: 0;
  padding: 8px;
  grid-column: auto;
}

.rv-rail .rack-filler-btn {
  width: 100%;
  justify-content: flex-start;
  text-align: left;
}

/* Los textos de ayuda son para la barra horizontal; en vertical solo estorban. */
.rv-rail .rack-filler-hint { display: none; }

.rv-rail-kpis {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.rv-rail-kpis .rv-stat-chip {
  min-width: 0;
  padding: 5px 6px;
}

.rv-rail-kpis .rv-stat-n { font-size: 0.95rem; }
.rv-rail-kpis .rv-stat-lbl { font-size: 0.55rem; }

.rv-rail .rack-unplaced {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}

.rv-rail .rack-unplaced-list {
  flex: 1 1;
  min-height: 0;
  max-height: none;
}

@media (max-width: 1180px) {
  .rv--fullscreen .rack-viewer-grid {
    grid-template-columns: 170px minmax(0, 1fr) 190px;
    gap: 8px;
  }
  .rv--fullscreen .rack-side { font-size: 0.92em; }
}

@media (max-width: 980px) {
  .rv--fullscreen .rack-viewer-grid {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
  }
  .rv--fullscreen .rack-side { display: none; }
  .rv--fullscreen .rv-rail {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    height: auto;
    max-height: 40%;
  }
  .rv--fullscreen .rv-rail .rack-filler-toolbar { flex: 1 1 240px; }
  .rv--fullscreen .rv-rail .rack-filler-btn { width: auto; }
  .rv--fullscreen .rv-rail-kpis { flex: 1 1 180px; }
  .rv--fullscreen .rv-rail .rack-unplaced { flex: 1 1 100%; }
}

/* ── Móvil: una cara debajo de la otra ────────────────────────────────────
   En modo táctil el componente ya enseña una cara cada vez. Pero si un móvil
   o una ventana estrecha llega sin \`pointer: coarse\`, el grid partía el ancho
   en front | canal | rear y cada rack quedaba en 78 px: una tira ilegible.
   Aquí las dos caras se apilan a todo el ancho y el canal de cableado (que
   necesita medir el frontal) se oculta. */
@media (max-width: 700px) {
  .rack-dual {
    grid-template-columns: minmax(0, 1fr);
    /* Dos caras apiladas: cada una se acota con su \`max-height\` y el tablero
     * hace el scroll; las filas vuelven a su alto natural. */
    grid-template-rows: none;
  }

  .rack-panel--duct { display: none; }

  .rack-columns {
    max-height: 60dvh;
  }

  .rack-board { padding: 8px; }
}




`, "",{"version":3,"sources":["webpack://./src/components/RackViewer.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;;;;;;;;;+EAS+E;AAC/E;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB;8EAC4E;EAC5E,SAAO;EACP,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,2EAA2E;EAC3E,+EAA+E;EAC/E;uEACqE;EACrE,kCAAkC;EAClC,SAAS;EACT,oBAAoB;EACpB;0EACwE;EACxE,UAAU;AACZ;;AAEA;4DAC4D;AAC5D;EACE;IACE,0DAA0D;EAC5D;EACA,iCAAiC,aAAa,EAAE;AAClD;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA,qCAAqC,aAAa,EAAE;AACtD;;AAEA,+EAA+E;AAC/E;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;gEAEgE;AAChE;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;EACE;;;;;;GAMC;EACD,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;gEACgE;AAChE;EACE,mCAAmC;EACnC,mBAAmB;EACnB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,WAAW,+BAA+B,EAAE;EAC5C,WAAW,sCAAsC,EAAE;AACrD;;AAEA;EACE,gBAAgB;EAChB;kDACgD;EAChD,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4EAA4E;EAC5E,2EAA2E;EAC3E;gFAC8E;EAC9E,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;AACA,2EAA2E;AAC3E;EACE,kCAAkC;AACpC;AACA;wBACwB;AACxB;EACE,uCAAuC;AACzC;AACA;sDACsD;AACtD;;EAEE,mBAAmB;EACnB;4CAC0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;2EAC2E;AAC3E;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,2EAA2E;EAC3E,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,mFAAmF;AACnF;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE;;yFAEuF;EACvF,oBAAoB;EACpB,yEAAyE;EACzE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR;;;;yBAIuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;AACpB;AACA,0DAA0D;AAC1D;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB;gFAC8E;EAC9E,qCAAqC;EACrC,QAAQ;EACR,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,yFAAyF;EACzF,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,6CAA6C;EAC7C,QAAQ;AACV;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;AACA,gCAAgC,0BAA0B,EAAE;AAC5D;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gFAAgF;AAChF;;;;EAIE,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;mFACmF;AACnF;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA,+DAA+D;AAC/D;EACE,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA,iEAAiE;AACjE,mBAAmB,aAAa,EAAE;AAClC;EACE,KAAK,sBAAsB,EAAE;AAC/B;AACA;EACE,mBAAmB,eAAe,EAAE;AACtC;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;AACA;0EAC0E;AAC1E;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,wCAAwC;EACxC,8BAA8B;EAC9B;;yFAEuF;EACvF,+BAA+B;EAC/B,kDAAkD;AACpD;AACA,4CAA4C;AAC5C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;AACA,iBAAiB,sBAAsB,EAAE,UAAU,EAAE;AACrD;EACE,qFAAqF;AACvF;AACA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;AACA,gCAAgC,cAAc,EAAE;AAChD;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,+EAA+E;AACjF;AACA,+BAA+B,cAAc,EAAE;;AAE/C,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,8CAA8C;EAC9C,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,yEAAyE;EACzE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,6BAA6B,wBAAwB,EAAE;;AAEvD,wCAAwC;AACxC;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;AACA,oBAAoB,gBAAgB,EAAE;AACtC,uBAAuB,aAAa,EAAE,kBAAkB,EAAE,YAAY,EAAE;AACxE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,sBAAsB;EACtB,gBAAgB;AAClB;AACA,0BAA0B,YAAY,EAAE,eAAe,EAAE;AACzD,oBAAoB,6BAA6B,EAAE,kBAAkB,EAAE;;AAEvE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;;;8DAK8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT;oEACkE;EAClE,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B;;;;;GAKC;EACD,sCAAsC;EACtC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;iFACiF;AACjF;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;gFACgF;AAChF,yBAAyB,mCAAmC,EAAE,qCAAqC,EAAE;AACrG,yBAAyB,mCAAmC,EAAE,qCAAqC,EAAE;AACrG,yBAAyB,oCAAoC,EAAE,sCAAsC,EAAE;AACvG,yBAAyB,oCAAoC,EAAE,sCAAsC,EAAE;;AAEvG;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,oCAAoC,qBAAqB,EAAE;AAC3D,oCAAoC,uBAAuB,EAAE;AAC7D,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,uBAAuB,EAAE;;AAE7D;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,YAAY,EAAE;AAC5B;;AAEA;;8DAE8D;AAC9D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;;AAEvC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,0BAA0B;IAC1B;;0EAEsE;IACtE,oDAAoD;EACtD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;sEACsE;AACtE;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;;;;;;;;;;gFAWgF;;AAEhF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;;;;0CAIwC;EACxC,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB;8EAC4E;EAC5E,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gCAAgC,iBAAiB,EAAE;AACnD,gCAAgC,aAAa,EAAE;AAC/C,iCAAiC,WAAW,EAAE,YAAY,EAAE;;AAE5D;EACE,SAAO;EACP,aAAa;EACb,iDAAiD;EACjD,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mEAAmE;EACnE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF,6BAA6B,aAAa,EAAE;;AAE5C;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,2BAA2B,kBAAkB,EAAE;AAC/C,6BAA6B,kBAAkB,EAAE;;AAEjD;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,iDAAiD;IACjD,QAAQ;EACV;EACA,6BAA6B,iBAAiB,EAAE;AAClD;;AAEA;EACE;IACE,qCAAqC;IACrC,uCAAuC;EACzC;EACA,6BAA6B,aAAa,EAAE;EAC5C;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;EACA,gDAAgD,eAAe,EAAE;EACjE,4CAA4C,WAAW,EAAE;EACzD,gCAAgC,eAAe,EAAE;EACjD,0CAA0C,cAAc,EAAE;AAC5D;;AAEA;;;;;0CAK0C;AAC1C;EACE;IACE,qCAAqC;IACrC;6DACyD;IACzD,wBAAwB;EAC1B;;EAEA,oBAAoB,aAAa,EAAE;;EAEnC;IACE,iBAAiB;EACnB;;EAEA,cAAc,YAAY,EAAE;AAC9B","sourcesContent":["/* Rack Viewer Styles */\r\n\r\n/* Lienzo de diseño A SANGRE, igual que el mapa de planta (`FloorPlanMap`).\r\n *\r\n * Antes era una tarjeta con borde, esquinas y sombra, y `height: calc(100vh -\r\n * 150px)`: en una pantalla grande el conjunto quedaba como una isla centrada\r\n * con aire por los cuatro lados (y el alto no cuadraba con el layout). Ahora la\r\n * ruta entra en `isCanvasRoute` (ver `MainLayout.jsx`): sin el relleno del\r\n * `main-content` ni el tope de 1400 px, y el visor hereda el alto del layout y\r\n * lo reparte con flex. La cabecera y los paneles interiores llegan hasta los\r\n * bordes: ni un píxel muerto entre el menú lateral y el rack.\r\n * No es \"pantalla completa\": la barra superior y el menú lateral siguen ahí. */\r\n.rack-viewer-container {\r\n  animation: fadeIn 0.3s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* Alto heredado del layout (`.content-wrapper.is-canvas > *` ya le da\r\n   * `flex: 1`): un `height` fijo contra el viewport dejaba franjas muertas. */\r\n  flex: 1;\r\n  height: 100%;\r\n  min-height: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  background: var(--bg-card);\r\n  border: 0;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.rack-viewer-header {\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid var(--border);\r\n}\r\n\r\n.rack-viewer-header h1 {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.rack-viewer-header p {\r\n  color: var(--text-muted);\r\n  margin: 0;\r\n}\r\n\r\n.rack-viewer-content {\r\n  display: grid;\r\n  grid-template-columns: 1fr 300px;\r\n  gap: 2rem;\r\n}\r\n\r\n.rack-diagram {\r\n  background-color: var(--bg-card);\r\n  padding: 1.5rem;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.rack-viewer-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.rack-viewer-grid {\r\n  display: grid;\r\n  flex: 1;\r\n  min-height: 0;\r\n  /* Los paneles laterales tienen tope: el ancho que sobre es para el rack. */\r\n  grid-template-columns: minmax(170px, 210px) minmax(0, 1fr) minmax(230px, 280px);\r\n  /* UNA fila que mide exactamente el hueco disponible. Sin esto la fila crecía\r\n   * con el contenido (42U ≈ 1.600 px) y el rack se salía del lienzo. */\r\n  grid-template-rows: minmax(0, 1fr);\r\n  gap: 10px;\r\n  align-items: stretch;\r\n  /* Sin relleno: los paneles tocan el menú lateral, la cabecera y el borde\r\n   * inferior. El aire va DENTRO de cada panel, no alrededor del lienzo. */\r\n  padding: 0;\r\n}\r\n\r\n/* En pantallas estrechas el panel de información estorba más que ayuda (es el\r\n * mismo criterio que ya usaba el modo pantalla completa). */\r\n@media (max-width: 1180px) {\r\n  .rack-viewer-grid {\r\n    grid-template-columns: minmax(160px, 190px) minmax(0, 1fr);\r\n  }\r\n  .rack-viewer-grid > .rack-side { display: none; }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .rack-viewer-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n  .rack-viewer-grid > .rack-unplaced { display: none; }\r\n}\r\n\r\n/* Los paneles interiores no llevan sombra propia: la superficie ya la tiene. */\r\n.rack-unplaced, .rack-side, .rack-board {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 12px;\r\n  box-shadow: none;\r\n  min-height: 0;\r\n  max-height: 100%;\r\n}\r\n\r\n/* A sangre las esquinas redondeadas de los paneles exteriores quedan pegadas a\r\n * los bordes de la ventana y parecen un hueco: se cuadran. En pantalla completa\r\n * (`.rv--fullscreen`) hay margen, así que conservan su radio. */\r\n.rack-viewer-container:not(.rv--fullscreen) :is(.rack-unplaced, .rack-side, .rack-board) {\r\n  border-radius: 0;\r\n}\r\n\r\n.rack-unplaced-list {\r\n  flex: 1;\r\n  min-height: 0;\r\n  max-height: none;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.rack-chip {\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: 10px;\r\n  padding: 8px 10px;\r\n  background: var(--bg-input);\r\n  cursor: grab;\r\n  transition: opacity 0.15s, box-shadow 0.15s;\r\n}\r\n\r\n.rack-chip--dragging {\r\n  opacity: 0.4;\r\n}\r\n\r\n.rack-chip:hover {\r\n  border-color: #93c5fd;\r\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\r\n}\r\n\r\n.rack-unplaced-hint {\r\n  font-size: 0.7rem;\r\n  color: #9ca3af;\r\n  text-align: center;\r\n  padding: 4px 0 8px;\r\n  border-bottom: 1px dashed var(--slate-300);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.rack-unplaced--over {\r\n  background: rgba(59,130,246,.1);\r\n  border-color: #3b82f6;\r\n  border-style: dashed;\r\n}\r\n\r\n.rack-slot--over {\r\n  background: rgba(59, 130, 246, 0.08);\r\n  border-color: #3b82f6 !important;\r\n  border-style: dashed !important;\r\n}\r\n\r\n/* Rear slot blocked by a full-depth front element */\r\n.rack-slot--blocked {\r\n  background: repeating-linear-gradient(\r\n    45deg,\r\n    var(--border),\r\n    var(--border) 5px,\r\n    var(--bg-toolbar) 5px,\r\n    var(--bg-toolbar) 10px\r\n  );\r\n  cursor: not-allowed !important;\r\n  opacity: 0.75;\r\n}\r\n\r\n.rack-item--dragging {\r\n  opacity: 0.35;\r\n  cursor: grabbing;\r\n}\r\n\r\n/* Elemento resaltado al llegar con ?destacar=<id> (p. ej. «Ver rack» desde la\r\n   ficha de un servidor). Parpadea unas veces y se apaga solo. */\r\n.rack-item--highlight {\r\n  outline: 3px solid var(--amber-600);\r\n  outline-offset: 1px;\r\n  z-index: 4;\r\n  animation: rack-item-pulse 1.1s ease-in-out 3;\r\n}\r\n\r\n@keyframes rack-item-pulse {\r\n  0%, 100% { box-shadow: 0 0 0 0 transparent; }\r\n  50%      { box-shadow: 0 0 0 5px var(--amber-600); }\r\n}\r\n\r\n.rack-board {\r\n  overflow-x: auto;\r\n  /* El tablero es una columna flex: las barras arriba con su alto natural y el\r\n   * rack con el resto, sin desbordar el lienzo. */\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  /* Ancla del tooltip de los puertos (`.rv-cable-tip`). */\r\n  position: relative;\r\n}\r\n\r\n.rack-dual {\r\n  display: grid;\r\n  /* Frontal | canal de cableado (estrecho) | trasero. Los cables no cruzan. */\r\n  grid-template-columns: minmax(0, 1fr) clamp(42px, 6vw, 96px) minmax(0, 1fr);\r\n  /* Barras de acción con alto natural y la fila de los tres paneles con todo\r\n   * lo que sobra: así el scroll vive dentro de las U y no se sale del lienzo. */\r\n  grid-template-rows: auto auto minmax(0, 1fr);\r\n  column-gap: 6px;\r\n  row-gap: 12px;\r\n  flex: 1;\r\n  min-height: 0;\r\n  position: relative;\r\n}\r\n/* En pantalla completa las barras viven en el rail (no dentro del rack). */\r\n.rv--fullscreen .rack-dual {\r\n  grid-template-rows: minmax(0, 1fr);\r\n}\r\n/* En modo tablet solo se pinta la barra de accesorios (el alta rápida está en\r\n * la barra inferior). */\r\n.rv--touch .rack-dual {\r\n  grid-template-rows: auto minmax(0, 1fr);\r\n}\r\n/* Las barras de acción van dentro del grid: deben ocupar la fila entera para\r\n   no robar una columna a los tres paneles del rack. */\r\n.rack-dual > .rack-add-toolbar,\r\n.rack-dual > .rack-filler-toolbar {\r\n  grid-column: 1 / -1;\r\n  /* El aire entre filas ya lo pone `row-gap`: con el margen propio se sumaban\r\n   * 22 px de hueco muerto antes del rack. */\r\n  margin-bottom: 0;\r\n}\r\n\r\n.rack-panel {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n/* Los dos paneles laterales se estiran hasta la altura del rack y hacen su\r\n * propio scroll: así el conjunto no queda como un pegote a media altura. */\r\n.rack-unplaced,\r\n.rack-side {\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n.rack-unplaced .d-flex,\r\n.rack-side .rv-spec-header {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ─── Dual panel (front + rear) ─── */\r\n.rack-dual {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) clamp(42px, 6vw, 96px) minmax(0, 1fr);\r\n  column-gap: 6px;\r\n  row-gap: 12px;\r\n}\r\n\r\n.rack-panel {\r\n  min-width: 0;\r\n}\r\n\r\n/* ─── Columna central de cableado ─── */\r\n.rack-panel--duct {\r\n  min-width: 0;\r\n}\r\n.rack-panel-label--duct {\r\n  background: rgba(148, 163, 184, 0.16);\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n/* Especificidad extra: `.rack-columns` (más abajo) fija 46px 1fr para la escala. */\r\n.rack-panel--duct .rack-columns--duct {\r\n  grid-template-columns: 1fr;\r\n  padding-right: 0;\r\n}\r\n.rack-canvas--duct {\r\n  background:\r\n    repeating-linear-gradient(90deg, rgba(148, 163, 184, 0.10) 0 2px, transparent 2px 12px),\r\n    linear-gradient(180deg, rgba(148, 163, 184, 0.10) 0%, rgba(148, 163, 184, 0.04) 100%);\r\n  border-style: dashed;\r\n  /* Deja que el cable sobresalga para empalmar con el tramo del frontal. */\r\n  overflow: visible;\r\n}\r\n.rack-canvas--duct .rv-cables {\r\n  z-index: 2;\r\n  overflow: visible;\r\n}\r\n\r\n.rack-panel-label {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  padding: 4px 10px;\r\n  border-radius: 6px;\r\n  margin-bottom: 6px;\r\n  display: inline-block;\r\n}\r\n\r\n.rack-panel-label--front {\r\n  background: rgba(59,130,246,.18);\r\n  color: #93c5fd;\r\n}\r\n\r\n.rack-panel-label--rear {\r\n  background: rgba(250,204,21,.18);\r\n  color: #fde047;\r\n}\r\n\r\n.rack-columns {\r\n  display: grid;\r\n  grid-template-columns: 30px 1fr;\r\n  gap: 2px;\r\n  /* Scroll propio: 42U × 38 px son ~1.600 px, así que las U se desplazan dentro\r\n   * de su columna y la cabecera del rack y el panel lateral no se van de la\r\n   * vista. El alto lo reparte el flex del lienzo: con un `max-height` en px\r\n   * contra el viewport, en cuanto cambiaba el alto de la cabecera el rack\r\n   * quedaba recortado. */\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  max-height: none;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n  scrollbar-gutter: stable;\r\n  padding-right: 2px;\r\n}\r\n/* La columna del canal no lleva escala: una sola pista. */\r\n.rack-columns.rack-columns--duct {\r\n  grid-template-columns: 1fr;\r\n  padding-right: 0;\r\n}\r\n\r\n.rack-scale {\r\n  display: grid;\r\n  grid-auto-rows: 36px;\r\n  gap: 2px;\r\n  justify-items: center;\r\n  align-content: start;\r\n  color: var(--text-secondary);\r\n  font-size: 9.5px;\r\n}\r\n\r\n.rack-canvas {\r\n  display: grid;\r\n  grid-auto-rows: 36px;\r\n  /* Una sola columna que mide EXACTAMENTE el ancho del rack: sin esto la\r\n     columna crece con el texto de la banda y los puertos se van a la derecha. */\r\n  grid-template-columns: minmax(0, 1fr);\r\n  gap: 2px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  align-content: start;\r\n  background: linear-gradient(180deg, rgba(255,255,255,.04) 0%, rgba(255,255,255,.02) 100%);\r\n  position: relative;\r\n}\r\n\r\n/* Barra de capas (colocación / cableado) */\r\n.rv-layer-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 0.5rem;\r\n}\r\n.rv-layer-switch {\r\n  display: inline-flex;\r\n  padding: 2px;\r\n  border-radius: 9px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar, var(--bg-card));\r\n  gap: 2px;\r\n}\r\n.rv-layer-switch button {\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  font-size: 0.76rem;\r\n  font-weight: 600;\r\n  padding: 5px 12px;\r\n  border-radius: 7px;\r\n  cursor: pointer;\r\n  transition: background 0.12s, color 0.12s;\r\n}\r\n.rv-layer-switch button:hover { color: var(--text-primary); }\r\n.rv-layer-switch button.is-on {\r\n  background: var(--bg-card);\r\n  color: var(--text-primary);\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);\r\n}\r\n.rv-layer-count {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* Capa de cableado: el texto de la banda estorba sobre los puertos → tooltip. */\r\n.rack-board.is-cabling .rack-item-row,\r\n.rack-board.is-cabling .rack-item-header,\r\n.rack-board.is-cabling .rack-item-type,\r\n.rack-board.is-cabling .rack-item-ports {\r\n  display: none;\r\n}\r\n.rack-board.is-cabling .rack-item {\r\n  cursor: grab;\r\n}\r\n\r\n/* Capa ÚNICA de cables sobre el tablero. Acompaña al scroll con un translate\r\n   del grupo interior, así nunca se queda «pegada». Recorta a la ventana visible. */\r\n.rv-cable-overlay {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n  z-index: 6;\r\n  overflow: hidden;\r\n}\r\n.rv-cable {\r\n  fill: none;\r\n  stroke-width: 1.6;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n  opacity: 0.9;\r\n  transition: stroke-width 0.12s, opacity 0.12s;\r\n}\r\n.rv-cable.is-backbone {\r\n  stroke-width: 2;\r\n  opacity: 1;\r\n}\r\n/* Cable iluminado: más grueso y con corriente recorriéndolo. */\r\n.rv-cable.is-hot {\r\n  stroke-width: 3;\r\n  opacity: 1;\r\n  stroke-dasharray: 7 5;\r\n  filter: drop-shadow(0 0 4px currentColor);\r\n  animation: rv-flow 0.55s linear infinite;\r\n}\r\n/* Cuando hay un camino encendido, el resto de cables se apaga. */\r\n.rv-cable.is-dim { opacity: 0.12; }\r\n@keyframes rv-flow {\r\n  to { stroke-dashoffset: -12; }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .rv-cable.is-hot { animation: none; }\r\n}\r\n\r\n/* Puertos del frontal: cubren toda la banda; la rejilla la pone el inline-style. */\r\n.rv-ports {\r\n  position: absolute;\r\n  inset: 0;\r\n  pointer-events: none;\r\n}\r\n/* Conector RJ45 estilizado: cuerpo con la pestaña (clip) abajo y los contactos\r\n   dorados dentro. Tamaño lo pone el inline-style (se reparte por la U). */\r\n.rv-port {\r\n  position: absolute;\r\n  padding: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  pointer-events: auto;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 0.08s, filter 0.12s;\r\n}\r\n.rv-port-jack {\r\n  position: absolute;\r\n  inset: 0;\r\n  border: 1px solid rgba(15, 23, 42, 0.55);\r\n  border-radius: 2px 2px 3px 3px;\r\n  background:\r\n    linear-gradient(#f8fafc, #e2e8f0),\r\n    repeating-linear-gradient(90deg, rgba(180, 130, 20, 0.55) 0 1px, transparent 1px 3px);\r\n  background-blend-mode: multiply;\r\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\r\n}\r\n/* Pestaña del conector (el clip del RJ45) */\r\n.rv-port-jack::after {\r\n  content: '';\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: -2px;\r\n  width: 40%;\r\n  height: 3px;\r\n  transform: translateX(-50%);\r\n  border-radius: 0 0 2px 2px;\r\n  background: inherit;\r\n  border: 1px solid rgba(15, 23, 42, 0.45);\r\n  border-top: 0;\r\n}\r\n.rv-port-num {\r\n  position: relative;\r\n  z-index: 1;\r\n  font-size: 7px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #334155;\r\n  pointer-events: none;\r\n}\r\n.rv-port:hover { transform: scale(1.12); z-index: 3; }\r\n.rv-port:hover .rv-port-jack {\r\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.7);\r\n}\r\n.rv-port.is-busy .rv-port-jack {\r\n  background: linear-gradient(#3b82f6, #2563eb);\r\n  border-color: #1d4ed8;\r\n}\r\n.rv-port.is-busy .rv-port-num { color: #eff6ff; }\r\n.rv-port.is-selected .rv-port-jack {\r\n  background: linear-gradient(#fbbf24, #f59e0b);\r\n  border-color: #b45309;\r\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.7);\r\n}\r\n/* Puerto iluminado (él o su cable al pasar el ratón) */\r\n.rv-port.is-hot {\r\n  transform: scale(1.3);\r\n  z-index: 4;\r\n}\r\n.rv-port.is-hot .rv-port-jack {\r\n  background: linear-gradient(#fb923c, #f97316);\r\n  border-color: #c2410c;\r\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.5), 0 0 8px rgba(249, 115, 22, 0.85);\r\n}\r\n.rv-port.is-hot .rv-port-num { color: #fff7ed; }\r\n\r\n/* Tooltip del puerto con los equipos conectados */\r\n.rv-cable-tip {\r\n  position: absolute;\r\n  z-index: 30;\r\n  min-width: 190px;\r\n  max-width: 320px;\r\n  padding: 7px 9px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card, #fff);\r\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);\r\n  font-size: 0.72rem;\r\n  color: var(--text-primary);\r\n  pointer-events: none;\r\n  /* Anclado a la izquierda del puerto: su borde derecho queda en `left`. */\r\n  transform: translateX(-100%);\r\n}\r\n.rv-cable-tip-head {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  font-weight: 700;\r\n  margin-bottom: 4px;\r\n}\r\n.rv-cable-tip-head span {\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n}\r\n.rv-cable-tip-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  padding: 2px 0;\r\n  border-top: 1px solid var(--border);\r\n}\r\n.rv-cable-tip-row em {\r\n  font-style: normal;\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n}\r\n/* Sede de una toma de pared: el otro extremo no está en este armario. */\r\n.rv-cable-tip-loc {\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n}\r\n.rv-cable-tip-row.is-muted { color: var(--text-muted); }\r\n\r\n/* Barra de conexión en el propio rack */\r\n.rv-connect-hint,\r\n.rv-connect-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  padding: 0.5rem 0.75rem;\r\n  margin-bottom: 0.6rem;\r\n  border-radius: 10px;\r\n  font-size: 0.78rem;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n}\r\n.rv-connect-hint {\r\n  border-color: rgba(245, 158, 11, 0.55);\r\n  background: rgba(245, 158, 11, 0.10);\r\n}\r\n.rv-connect-hint button {\r\n  margin-left: auto;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n  font-size: 0.74rem;\r\n  text-decoration: underline;\r\n}\r\n.rv-connect-title { font-weight: 600; }\r\n.rv-connect-title em { margin: 0 6px; font-style: normal; opacity: 0.6; }\r\n.rv-connect-bar select {\r\n  padding: 3px 6px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-surface, #fff);\r\n  color: var(--text-primary);\r\n  font-size: 0.76rem;\r\n}\r\n.rv-connect-bar button {\r\n  padding: 4px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-surface, #fff);\r\n  color: var(--text-primary);\r\n  font-size: 0.76rem;\r\n  cursor: pointer;\r\n}\r\n.rv-connect-ok {\r\n  background: var(--primary, #2563eb) !important;\r\n  border-color: var(--primary, #2563eb) !important;\r\n  color: #fff !important;\r\n  font-weight: 600;\r\n}\r\n.rv-connect-ok:disabled { opacity: 0.6; cursor: default; }\r\n.rv-connect-error { color: var(--danger, #dc2626); font-size: 0.74rem; }\r\n\r\n.rack-slot {\r\n  position: relative;\r\n  min-height: 36px;\r\n  border: 1px dashed transparent;\r\n}\r\n\r\n.rack-slot:hover {\r\n  border-color: rgba(148, 163, 184, 0.45);\r\n}\r\n\r\n.rack-item {\r\n  width: 100%;\r\n  min-width: 0;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 3px 10px;\r\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.3);\r\n  cursor: grab;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 1px;\r\n  overflow: hidden;\r\n}\r\n\r\n.rack-item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  overflow: hidden;\r\n  min-width: 0;\r\n}\r\n\r\n/* Compact single-row layout for 1U items */\r\n.rack-item-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  overflow: hidden;\r\n  min-width: 0;\r\n  width: 100%;\r\n}\r\n\r\n.rack-item-row .rack-item-title {\r\n  flex: 1;\r\n}\r\n\r\n.rack-item-row .rack-item-ports {\r\n  flex-shrink: 0;\r\n  margin-top: 0;\r\n}\r\n\r\n.rack-item-title {\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  line-height: 1.35;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n/* 1U: name fills the slot, slightly larger for legibility */\r\n.rack-item-title--1u {\r\n  font-size: 13px;\r\n  text-align: center;\r\n  flex: none;\r\n  width: 100%;\r\n}\r\n\r\n.rack-item-type {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  opacity: 0.9;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  line-height: 1;\r\n  margin-top: 1px;\r\n  padding-left: 24px;\r\n}\r\n\r\n.rack-item-ports {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  opacity: 1;\r\n  line-height: 1;\r\n  margin-top: 0;\r\n}\r\n\r\n.port-count-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  border: 1px solid rgba(0,0,0,0.1);\r\n}\r\n\r\n.spec-group {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.spec {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 6px 0;\r\n  font-size: 13px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.spec span:first-child {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.spec span:last-child {\r\n  text-align: right;\r\n  font-weight: 600;\r\n}\r\n\r\n.spec--stacked {\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.rv-inline-help {\r\n  display: block;\r\n  font-size: 0.72rem;\r\n  line-height: 1.4;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Print Styles */\r\n@media print {\r\n  .sidebar {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* ─────────────────────────────────────────────────────────\r\n   Cabecera\r\n   Va con los tokens del tema: antes era un degradado azul marino fijo que\r\n   chocaba con cualquier paleta clara y dejaba las etiquetas de los KPIs\r\n   (color secundario del tema) casi ilegibles sobre el fondo oscuro.\r\n   ───────────────────────────────────────────────────────── */\r\n.rv-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  /* A sangre: el contenido arranca alineado con el de los paneles (12 px de\r\n   * relleno + 1 px de borde), no con un margen propio de tarjeta. */\r\n  padding: 0.75rem 13px;\r\n  margin-bottom: 0;\r\n  background-color: transparent;\r\n  background-image: linear-gradient(\r\n    120deg,\r\n    rgba(var(--accent-rgb), 0.14) 0%,\r\n    rgba(var(--accent-rgb), 0.04) 42%,\r\n    transparent 70%\r\n  );\r\n  border-bottom: 1px solid var(--border);\r\n  border-radius: 0;\r\n  color: var(--text-primary);\r\n  box-shadow: none;\r\n}\r\n\r\n.rv-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.85rem;\r\n}\r\n\r\n/* Icono del rack: el mismo `RectangleStackIcon` que el listado de racks, no el\r\n * emoji 🗄️, que se pintaba con los colores de la fuente y no pegaba con nada. */\r\n.rv-rack-glyph {\r\n  width: 28px;\r\n  height: 28px;\r\n  flex-shrink: 0;\r\n  color: var(--accent-l);\r\n  stroke-width: 1.6;\r\n}\r\n\r\n.rv-header-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n}\r\n\r\n.rv-title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.rv-rack-name {\r\n  margin: 0;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  line-height: 1.1;\r\n}\r\n\r\n.rv-code-pill {\r\n  background: rgba(var(--accent-rgb), 0.16);\r\n  color: var(--accent-l);\r\n  padding: 2px 10px;\r\n  border-radius: 20px;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  border: 1px solid rgba(var(--accent-rgb), 0.3);\r\n  text-transform: uppercase;\r\n}\r\n\r\n.rv-location-pill {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  padding: 2px 10px;\r\n  border-radius: 20px;\r\n  font-size: 0.72rem;\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.rv-rack-desc {\r\n  margin: 0;\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.rv-header-stats {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.rv-stat-chip {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 5px 14px;\r\n  min-width: 58px;\r\n}\r\n\r\n/* Semáforo de ocupación con los tokens funcionales del tema: en las paletas\r\n * claras el número oscurece y el fondo se tiñe poco; en las oscuras al revés. */\r\n.rv-stat-chip--used    { background: rgba(239, 68, 68, 0.14); border-color: rgba(239, 68, 68, 0.34); }\r\n.rv-stat-chip--free    { background: rgba(34, 197, 94, 0.14); border-color: rgba(34, 197, 94, 0.32); }\r\n.rv-stat-chip--depth   { background: rgba(14, 165, 233, 0.14); border-color: rgba(14, 165, 233, 0.32); }\r\n.rv-stat-chip--pending { background: rgba(251, 191, 36, 0.16); border-color: rgba(251, 191, 36, 0.36); }\r\n\r\n.rv-stat-n {\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  line-height: 1;\r\n}\r\n\r\n.rv-stat-chip--used    .rv-stat-n { color: var(--red-600); }\r\n.rv-stat-chip--free    .rv-stat-n { color: var(--green-600); }\r\n.rv-stat-chip--depth   .rv-stat-n { color: var(--blue-500); }\r\n.rv-stat-chip--pending .rv-stat-n { color: var(--amber-600); }\r\n\r\n.rv-stat-lbl {\r\n  font-size: 0.6rem;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  margin-top: 2px;\r\n}\r\n\r\n.rv-saving-pill {\r\n  background: rgba(251, 191, 36, 0.16);\r\n  border: 1px solid rgba(251, 191, 36, 0.4);\r\n  color: var(--amber-600);\r\n  padding: 5px 14px;\r\n  border-radius: 20px;\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  animation: rv-pulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes rv-pulse {\r\n  0%, 100% { opacity: 1; }\r\n  50%       { opacity: 0.6; }\r\n}\r\n\r\n/* ─────────────────────────────────────────────────────────\r\n   Sidebar: legend + occupancy + section headers\r\n   ───────────────────────────────────────────────────────── */\r\n.rv-spec-header {\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.07em;\r\n  color: var(--text-secondary);\r\n  padding-bottom: 6px;\r\n  margin-bottom: 6px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.rv-legend {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 5px 10px;\r\n  margin-bottom: 12px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.rv-legend-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.78rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.rv-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 3px;\r\n  flex-shrink: 0;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.15);\r\n}\r\n\r\n.rv-dot--server { background: #007bff; }\r\n.rv-dot--switch { background: #28a745; }\r\n.rv-dot--panel  { background: #17a2b8; }\r\n.rv-dot--pdu    { background: #ffc107; }\r\n\r\n.rv-occupancy {\r\n  margin-bottom: 14px;\r\n  padding-bottom: 14px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.rv-capacity-row {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.rv-capacity-row-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 0.74rem;\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.rv-capacity-track {\r\n  height: 7px;\r\n  background: rgba(148, 163, 184, 0.18);\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.rv-capacity-fill {\r\n  height: 100%;\r\n  border-radius: 4px;\r\n  transition: width 0.6s ease;\r\n}\r\n\r\n.rv-capacity-fill--front {\r\n  background: linear-gradient(90deg, #38bdf8 0%, #2563eb 100%);\r\n}\r\n\r\n.rv-capacity-fill--rear {\r\n  background: linear-gradient(90deg, #f59e0b 0%, #ef4444 100%);\r\n}\r\n\r\n.rv-occupancy-help {\r\n  margin-top: 8px;\r\n  font-size: 0.73rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.4;\r\n}\r\n\r\n.rv-power-panel {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.rv-power-summary-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.rv-power-summary-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  padding: 8px 6px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: rgba(15, 23, 42, 0.08);\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.rv-power-summary-value {\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.rv-power-summary-label {\r\n  font-size: 0.62rem;\r\n  line-height: 1.15;\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n  color: var(--text-secondary);\r\n  overflow-wrap: anywhere;\r\n  word-break: break-word;\r\n  hyphens: auto;\r\n}\r\n\r\n.rv-power-pdu-row {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.rv-power-pdu-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  margin-bottom: 4px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.rv-power-pdu-name {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.rv-power-pdu-metric {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.rv-power-track {\r\n  height: 7px;\r\n  background: rgba(148, 163, 184, 0.18);\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n}\r\n\r\n.rv-power-devices {\r\n  margin-top: 10px;\r\n  padding-top: 10px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.rv-power-devices-title {\r\n  margin-bottom: 6px;\r\n  font-size: 0.68rem;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n  color: var(--text-secondary);\r\n  font-weight: 700;\r\n}\r\n\r\n.rv-power-device-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 0;\r\n}\r\n\r\n.rv-power-device-name {\r\n  min-width: 0;\r\n  font-size: 0.75rem;\r\n  color: var(--text-primary);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.rv-power-state {\r\n  flex-shrink: 0;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  font-size: 0.65rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.rv-power-state--ok {\r\n  background: rgba(34, 197, 94, 0.18);\r\n  color: #166534;\r\n}\r\n\r\n.rv-power-state--warn {\r\n  background: rgba(245, 158, 11, 0.18);\r\n  color: #92400e;\r\n}\r\n\r\n.rv-power-state--off {\r\n  background: rgba(239, 68, 68, 0.18);\r\n  color: #991b1b;\r\n}\r\n\r\n.rv-empty-note {\r\n  font-size: 0.74rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .rack-viewer-grid {\r\n    grid-template-columns: 1fr;\r\n    /* Aquí sí quedan dos filas (pendientes + tablero): el panel de pendientes\r\n     * se lleva algo menos de un tercio y el rack el resto, ambos con scroll\r\n     * interior. Con una sola fila `1fr` el tablero se salía del lienzo. */\r\n    grid-template-rows: minmax(0, 0.34fr) minmax(0, 1fr);\r\n  }\r\n\r\n  .rack-unplaced-list {\r\n    max-height: none;\r\n  }\r\n\r\n  .rv-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .rv-power-summary-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* Por debajo de 900 px el panel de pendientes ya no se pinta: el tablero se\r\n   queda con toda la fila (si no, se quedaría con el 66 % del alto). */\r\n@media (max-width: 900px) {\r\n  .rack-viewer-grid {\r\n    grid-template-rows: minmax(0, 1fr);\r\n  }\r\n}\r\n\r\n/* ─── Rack Filler Toolbar ─── */\r\n.rack-filler-toolbar {\r\n  grid-column: 1 / -1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 10px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  margin-bottom: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.rack-filler-toolbar-label {\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.rack-filler-btn {\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  padding: 4px 10px;\r\n  border: 1.5px solid var(--border);\r\n  border-radius: 6px;\r\n  background: var(--bg-card);\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rack-filler-btn:hover {\r\n  border-color: rgba(148, 163, 184, 0.5);\r\n  background: rgba(255,255,255,.04);\r\n}\r\n\r\n.rack-filler-btn--active {\r\n  color: #fff;\r\n  border-color: transparent;\r\n}\r\n\r\n.rack-filler-hint {\r\n  font-size: 0.7rem;\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n}\r\n\r\n/* ─── Filler Item (inside rack slot) ─── */\r\n.rack-filler-item {\r\n  width: 100%;\r\n  height: 36px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  opacity: 0.85;\r\n  transition: opacity 0.15s;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.rack-filler-item:hover {\r\n  opacity: 1;\r\n  outline: 2px dashed var(--text-secondary);\r\n  outline-offset: -2px;\r\n}\r\n\r\n/* ─── Alta rápida desde el visor (barra + diálogo) ─── */\r\n.rack-add-toolbar {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n/* ─── Modo diseño (rack en borrador) ─── */\r\n.rv-design-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin: 12px 12px 0;\r\n  padding: 10px 14px;\r\n  border: 1px solid rgba(245, 158, 11, 0.45);\r\n  border-left: 4px solid #f59e0b;\r\n  border-radius: 10px;\r\n  background: rgba(245, 158, 11, 0.12);\r\n  color: var(--text-primary);\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.rv-design-banner-text {\r\n  line-height: 1.35;\r\n}\r\n\r\n.rv-design-banner-btn {\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 8px 14px;\r\n  background: #f59e0b;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  font-size: 0.82rem;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rv-design-banner-btn:hover {\r\n  background: #d97706;\r\n}\r\n\r\n.rack-add-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  background: transparent;\r\n  border-width: 1.5px;\r\n}\r\n\r\n.rack-add-btn:hover {\r\n  background: rgba(148, 163, 184, 0.12);\r\n}\r\n\r\n/* Diálogo «Nuevo switch / patch panel / PDU» */\r\n.rqc-context {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.rqc-chip {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  padding: 3px 9px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.rqc-name-row {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.rqc-ports-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.rqc-preset--active {\r\n  background: var(--accent);\r\n  border-color: var(--accent);\r\n  color: #fff;\r\n}\r\n\r\n.rqc-ports-input {\r\n  width: 72px;\r\n  min-width: 72px;\r\n  text-align: center;\r\n}\r\n\r\n.rqc-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  gap: 8px;\r\n}\r\n\r\n.rqc-grid select {\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.rqc-warn {\r\n  margin: 0.75rem 0 0;\r\n  font-size: 0.75rem;\r\n  line-height: 1.4;\r\n  color: var(--amber-600, #b45309);\r\n}\r\n\r\n.rqc-error {\r\n  margin: 0.75rem 0 0;\r\n  font-size: 0.78rem;\r\n  color: var(--red-500, #ef4444);\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   Pantalla completa — modo «trabajo»\r\n\r\n   Objetivo: montar y recolocar equipos sin pelear con la página. El rack se\r\n   lleva todo el alto/ancho y las herramientas (añadir equipo, añadir accesorio),\r\n   los KPIs y las U pendientes se apilan en una barra lateral izquierda. El panel\r\n   de detalle (capacidad, alimentación, elemento seleccionado) sigue a la derecha.\r\n\r\n   La geometría es flex, NO la medición en JS: aquí la cabecera de la app y el\r\n   menú lateral no existen, así que `.rack-columns` se reparte el alto sobrante\r\n   con `flex: 1` y se queda con su propio scroll.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n\r\n.rv-fs-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.rv-fs-btn:hover {\r\n  background: rgba(var(--accent-rgb), 0.14);\r\n  color: var(--text-primary);\r\n  border-color: rgba(var(--accent-rgb), 0.4);\r\n}\r\n\r\n.rv--fullscreen {\r\n  /* También sirve de respaldo cuando la Fullscreen API está bloqueada.\r\n     z-index POR DEBAJO de los diálogos (`.list-overlay` va en 1200): en el modo\r\n     de respaldo no hay capa superior del navegador, así que si el contenedor\r\n     quedara por encima, los diálogos saldrían invisibles. Por encima del menú\r\n     lateral y la barra superior (1100). */\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1150;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  background: var(--bg-card, #0f172a);\r\n  border: 0;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  overflow: hidden;\r\n  /* `inset: 0` basta para llenar la ventana; el `height` del lienzo normal\r\n     (calc(100vh - 150px)) dejaría el modo pantalla completa a media altura. */\r\n  height: auto;\r\n  min-height: 0;\r\n}\r\n\r\n.rv--fullscreen .rv-header {\r\n  margin-bottom: 0;\r\n  padding: 0.5rem 0.9rem;\r\n}\r\n\r\n.rv--fullscreen .rv-rack-name { font-size: 1.1rem; }\r\n.rv--fullscreen .rv-rack-desc { display: none; }\r\n.rv--fullscreen .rv-rack-glyph { width: 22px; height: 22px; }\r\n\r\n.rv--fullscreen .rack-viewer-grid {\r\n  flex: 1;\r\n  min-height: 0;\r\n  grid-template-columns: 186px minmax(0, 1fr) 214px;\r\n  align-items: stretch;\r\n  gap: 12px;\r\n  padding: 0;\r\n}\r\n\r\n.rv--fullscreen .rack-board {\r\n  height: 100%;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.rv--fullscreen .rack-dual {\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.rv--fullscreen .rack-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n.rv--fullscreen .rack-columns {\r\n  flex: 1;\r\n  min-height: 0;\r\n  /* Manda el flex: la medición en px es solo para la vista normal. */\r\n  max-height: none;\r\n}\r\n\r\n.rv--fullscreen .rack-side,\r\n.rv--fullscreen .rv-rail {\r\n  height: 100%;\r\n  max-height: 100%;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n/* ─── Barra lateral de herramientas ─── */\r\n.rv-rail {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 10px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.rv-rail .rack-filler-toolbar {\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 6px;\r\n  margin-bottom: 0;\r\n  padding: 8px;\r\n  grid-column: auto;\r\n}\r\n\r\n.rv-rail .rack-filler-btn {\r\n  width: 100%;\r\n  justify-content: flex-start;\r\n  text-align: left;\r\n}\r\n\r\n/* Los textos de ayuda son para la barra horizontal; en vertical solo estorban. */\r\n.rv-rail .rack-filler-hint { display: none; }\r\n\r\n.rv-rail-kpis {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 6px;\r\n}\r\n\r\n.rv-rail-kpis .rv-stat-chip {\r\n  min-width: 0;\r\n  padding: 5px 6px;\r\n}\r\n\r\n.rv-rail-kpis .rv-stat-n { font-size: 0.95rem; }\r\n.rv-rail-kpis .rv-stat-lbl { font-size: 0.55rem; }\r\n\r\n.rv-rail .rack-unplaced {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  background: transparent;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.rv-rail .rack-unplaced-list {\r\n  flex: 1;\r\n  min-height: 0;\r\n  max-height: none;\r\n}\r\n\r\n@media (max-width: 1180px) {\r\n  .rv--fullscreen .rack-viewer-grid {\r\n    grid-template-columns: 170px minmax(0, 1fr) 190px;\r\n    gap: 8px;\r\n  }\r\n  .rv--fullscreen .rack-side { font-size: 0.92em; }\r\n}\r\n\r\n@media (max-width: 980px) {\r\n  .rv--fullscreen .rack-viewer-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n    grid-template-rows: auto minmax(0, 1fr);\r\n  }\r\n  .rv--fullscreen .rack-side { display: none; }\r\n  .rv--fullscreen .rv-rail {\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    align-items: flex-start;\r\n    height: auto;\r\n    max-height: 40%;\r\n  }\r\n  .rv--fullscreen .rv-rail .rack-filler-toolbar { flex: 1 1 240px; }\r\n  .rv--fullscreen .rv-rail .rack-filler-btn { width: auto; }\r\n  .rv--fullscreen .rv-rail-kpis { flex: 1 1 180px; }\r\n  .rv--fullscreen .rv-rail .rack-unplaced { flex: 1 1 100%; }\r\n}\r\n\r\n/* ── Móvil: una cara debajo de la otra ────────────────────────────────────\r\n   En modo táctil el componente ya enseña una cara cada vez. Pero si un móvil\r\n   o una ventana estrecha llega sin `pointer: coarse`, el grid partía el ancho\r\n   en front | canal | rear y cada rack quedaba en 78 px: una tira ilegible.\r\n   Aquí las dos caras se apilan a todo el ancho y el canal de cableado (que\r\n   necesita medir el frontal) se oculta. */\r\n@media (max-width: 700px) {\r\n  .rack-dual {\r\n    grid-template-columns: minmax(0, 1fr);\r\n    /* Dos caras apiladas: cada una se acota con su `max-height` y el tablero\r\n     * hace el scroll; las filas vuelven a su alto natural. */\r\n    grid-template-rows: none;\r\n  }\r\n\r\n  .rack-panel--duct { display: none; }\r\n\r\n  .rack-columns {\r\n    max-height: 60dvh;\r\n  }\r\n\r\n  .rack-board { padding: 8px; }\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
